import { Injectable } from '@angular/core';
import { RequestsPermissions } from '../model/requestType.enum';
import { StorageService } from 'src/app/core/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class HandlePermissions {
  requestTypeEnum = RequestsPermissions;
  permissionString = '';
  index!: number;
  requestsPosition = new Map<string, number>();

  constructor(private storageService: StorageService) {}

  setRequestPosition() {
    this.storageService.get('config')
      ? (this.permissionString = this.storageService.get('config').permissions)
      : '';
    Array.from(this.permissionString);
    this.requestsPosition.set(this.requestTypeEnum.dotArr, 0);
    this.requestsPosition.set(this.requestTypeEnum.campaigns, 1);
    this.requestsPosition.set(this.requestTypeEnum.function, 2);
    this.requestsPosition.set(this.requestTypeEnum.provisional, 3);
    this.requestsPosition.set(this.requestTypeEnum.didactic, 4);
    this.requestsPosition.set(this.requestTypeEnum.generalServices, 5);
    this.requestsPosition.set(this.requestTypeEnum.innerRoute, 6);
    this.requestsPosition.set(this.requestTypeEnum.loanCarPool, 7);
    this.requestsPosition.set(this.requestTypeEnum.loanWedding, 8);
    this.requestsPosition.set(this.requestTypeEnum.loanLongTerms, 9);
    this.requestsPosition.set(this.requestTypeEnum.proyect, 10);
    this.requestsPosition.set(this.requestTypeEnum.judgements, 11);
    this.requestsPosition.set(this.requestTypeEnum.transfers, 12);
    this.requestsPosition.set(this.requestTypeEnum.redPlates, 13);
    this.requestsPosition.set(this.requestTypeEnum.redPlatesApprove, 14);
    this.requestsPosition.set(this.requestTypeEnum.vo, 15);
    this.requestsPosition.set(this.requestTypeEnum.es, 16);
    // CRMSP-7485 - Empleados VO
    this.requestsPosition.set(this.requestTypeEnum.companyAdminVO, 17);
  }

  getPermission(requestType: string): boolean {
    this.setRequestPosition();
    if (requestType === 'LOAN') {
      if (
        this.permissionString[7] === '1' ||
        this.permissionString[8] === '1' ||
        this.permissionString[9] === '1'
      ) {
        return true;
      } else {
        return false;
      }
    } else if (requestType === this.requestTypeEnum.es) {
      return true;
    } else {
      this.index = this.requestsPosition.get(requestType)!;
      return this.permissionString[this.index] === '1';
    }
  }
}
